import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Button from 'components/shared/button';
import SubMenu from 'components/shared/sub-menu';
import filterNonRootItems from 'utils/filter-non-root-items';

import MainContext from 'context/main';

import styles from './mobile-menu.module.scss';

const cx = classNames.bind(styles);

const MobileMenu = ({ className: additionalClassName, withBanner, isOpen }) => {
  // const {
  //   menus: {
  //     mobile: {
  //       menuItems: { nodes: menuItemsNodes },
  //     },
  //   },
  //   sharedBlocks: {
  //     mobileMenu: {
  //       acf: { button1Text, button1Link, button2Text, button2Link, button3Text, button3Link },
  //     },
  //   },
  // } = useContext(MainContext);

  const { menus, sharedBlocks } = useContext(MainContext);

  const menuItemsNodes = menus?.mobile?.menuItems?.nodes || [];
  const button1Text = sharedBlocks?.mobileMenu?.acf?.button1Text;
  const button1Link = sharedBlocks?.mobileMenu?.acf?.button1Link;
  const button2Text = sharedBlocks?.mobileMenu?.acf?.button2Text;
  const button2Link = sharedBlocks?.mobileMenu?.acf?.button2Link;
  const button3Text = sharedBlocks?.mobileMenu?.acf?.button3Text;
  const button3Link = sharedBlocks?.mobileMenu?.acf?.button3Link;

  const className = cx('wrapper', { withBanner, open: isOpen }, additionalClassName);

  // Graphql does not allow to filter by null values so has to do it manually
  const menuItems = filterNonRootItems(menuItemsNodes);

  return (
    <div className={className}>
      <div className={cx('container')}>
        <nav className={cx('inner')}>
          {menuItems.map((menuItem, index) => (
            <div className={cx('list')} key={index}>
              <h3 className={cx('subtitle')}>{menuItem.label}</h3>

              {menuItem.childItems.nodes.length > 0 && (
                <SubMenu
                  className={cx('sub-menu', {
                    doubleLayout: menuItem.childItems.nodes.every(
                      ({ description }) => !description
                    ),
                  })}
                  items={menuItem.childItems.nodes}
                />
              )}
            </div>
          ))}

          <div className={cx('buttons-wrapper')}>
            {button1Text && button1Link && (
              <Button className={cx('button')} to={button1Link} theme="tertiary" size="lg">
                {button1Text}
              </Button>
            )}
            {button2Text && button2Link && (
              <Button className={cx('button')} to={button2Link} theme="primary" size="lg">
                {button2Text}
              </Button>
            )}
            {button3Text && button3Link && (
              <Button className={cx('button')} to={button3Link} theme="accent-primary" size="lg">
                {button3Text}
              </Button>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

MobileMenu.propTypes = {
  className: PropTypes.string,
  withBanner: PropTypes.bool,
  isOpen: PropTypes.bool,
};

MobileMenu.defaultProps = {
  className: null,
  withBanner: true,
  isOpen: false,
};

export default MobileMenu;
